/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Earth_Day_2025_Impact_Co2_DescriptionInputs */

const en_earth_day_2025_impact_co2_description = /** @type {(inputs: Earth_Day_2025_Impact_Co2_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`That’s about 
${i?.number} km of car emissions`)
};

const ar_earth_day_2025_impact_co2_description = /** @type {(inputs: Earth_Day_2025_Impact_Co2_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`هذا حوالي 
${i?.number} كم من انبعاثات السيارات`)
};

const de_earth_day_2025_impact_co2_description = /** @type {(inputs: Earth_Day_2025_Impact_Co2_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Das sind ungefähr 
${i?.number} km Autoabgase`)
};

const es_earth_day_2025_impact_co2_description = /** @type {(inputs: Earth_Day_2025_Impact_Co2_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Eso equivale a 
${i?.number} km de emisiones de coches`)
};

const fr_earth_day_2025_impact_co2_description = /** @type {(inputs: Earth_Day_2025_Impact_Co2_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cela correspond aux émissions produites sur ${i?.number} km en voiture.`)
};

const it_earth_day_2025_impact_co2_description = /** @type {(inputs: Earth_Day_2025_Impact_Co2_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rappresenta circa 
${i?.number} km di emissioni`)
};

const ja_earth_day_2025_impact_co2_description = /** @type {(inputs: Earth_Day_2025_Impact_Co2_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`車が約${i?.number}km走行する時の
排気量に相当します`)
};

const ko_earth_day_2025_impact_co2_description = /** @type {(inputs: Earth_Day_2025_Impact_Co2_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`차량이 ${i?.number}km 주행했을 때
배출된 탄소량과 비슷해요`)
};

const pt_br_earth_day_2025_impact_co2_description = /** @type {(inputs: Earth_Day_2025_Impact_Co2_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Equivale a
${i?.number} km de emissões dos carros`)
};

const ru_earth_day_2025_impact_co2_description = /** @type {(inputs: Earth_Day_2025_Impact_Co2_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Это примерно 
${i?.number} км автомобильных выбросов`)
};

const th_earth_day_2025_impact_co2_description = /** @type {(inputs: Earth_Day_2025_Impact_Co2_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`นั่นมีขนาดเทียบเท่า
ไอเสียจากรถยนต์ใน ${i?.number} กม.`)
};

const tr_earth_day_2025_impact_co2_description = /** @type {(inputs: Earth_Day_2025_Impact_Co2_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bu yaklaşık 
${i?.number} km araba emisyonu demek`)
};

const zh_cn_earth_day_2025_impact_co2_description = /** @type {(inputs: Earth_Day_2025_Impact_Co2_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`相当于
汽车 ${i?.number} 公里的碳排放量`)
};

const zh_tw_earth_day_2025_impact_co2_description = /** @type {(inputs: Earth_Day_2025_Impact_Co2_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`相當於
汽車 ${i?.number} 公里的碳排放量`)
};

/**
* | output |
* | --- |
* | "That’s about {number} km of car emissions" |
*
* @param {Earth_Day_2025_Impact_Co2_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const earth_day_2025_impact_co2_description = /** @type {((inputs: Earth_Day_2025_Impact_Co2_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earth_Day_2025_Impact_Co2_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earth_day_2025_impact_co2_description(inputs)
	if (locale === "ar") return ar_earth_day_2025_impact_co2_description(inputs)
	if (locale === "de") return de_earth_day_2025_impact_co2_description(inputs)
	if (locale === "es") return es_earth_day_2025_impact_co2_description(inputs)
	if (locale === "fr") return fr_earth_day_2025_impact_co2_description(inputs)
	if (locale === "it") return it_earth_day_2025_impact_co2_description(inputs)
	if (locale === "ja") return ja_earth_day_2025_impact_co2_description(inputs)
	if (locale === "ko") return ko_earth_day_2025_impact_co2_description(inputs)
	if (locale === "pt_br") return pt_br_earth_day_2025_impact_co2_description(inputs)
	if (locale === "ru") return ru_earth_day_2025_impact_co2_description(inputs)
	if (locale === "th") return th_earth_day_2025_impact_co2_description(inputs)
	if (locale === "tr") return tr_earth_day_2025_impact_co2_description(inputs)
	if (locale === "zh_cn") return zh_cn_earth_day_2025_impact_co2_description(inputs)
	return zh_tw_earth_day_2025_impact_co2_description(inputs)
});